<div class="top-nav-container d-flex align-items-center w-full">
  <div class="app-name">
    <span class="app-emoji">📦</span>
    <span class="app-label">SCM</span>
  </div>
  <div class="d-flex align-items-center gap-20">

    <!-- Preferred Language Selection -->
    <app-select-preferred-lang [langs]="langs" [selectedLang]="selectedLangCode()" (selectedLangChange)="changeMyPreferredLang($event)" />

    <!-- user-menu-icon -->
    <div #userMenuIcon class="user-menu-icon" (click)="toggleMenu()">
      @if (user()?.avatar; as avatar) {
        <img src="{{ avatar | resource: 'thumb:240x' }}" />
      } @else {
        <div class="avatar-placeholder">
          {{ getInitials() }}
        </div>
      }
    </div>

    @if (showMenu()) {
      <div class="user-menu" #userMenu [class.rtl]="lang === 'ar'">
        <div class="user-menu-container">
          <!-- User Info Section -->
          <div class="user-info">
            <div class="avatar-section">
              @if (user()?.avatar; as avatar) {
                <img src="{{ avatar | resource: 'thumb:240x' }}" class="user-avatar" />
              } @else {
                <div class="user-avatar-placeholder">
                  {{ getInitials() }}
                </div>
              }
            </div>
            <div class="user-details">
              <div class="username">{{ user()?.name }}</div>
              <div class="user-email">{{ user()?.email }}</div>
            </div>
          </div>

          <!-- Menu Items -->
          <div class="menu-items">
            <div class="menu-item profile" routerLink="/dashboard/my-profile">
              <sxw-svg-icon name="profile" width="18" height="18" class="menu-icon"></sxw-svg-icon>
              <span class="menu-text">{{ "COMMON.VIEW_PROFILE" | translate }}</span>
            </div>

            <div class="menu-item">
              <sxw-svg-icon name="changelog" width="18" height="18" class="menu-icon"></sxw-svg-icon>
              <span class="menu-text">{{ "COMMON.CHANGELOG" | translate }}</span>
            </div>

            <div class="menu-item">
              <sxw-svg-icon name="support" width="18" height="18" class="menu-icon"></sxw-svg-icon>
              <span class="menu-text">{{ "COMMON.SUPPORT" | translate }}</span>
            </div>

            <div class="menu-item sign-out" (click)="logout()">
              <sxw-svg-icon name="sign-out" width="18" height="18" class="menu-icon"></sxw-svg-icon>
              <span class="menu-text">{{ "COMMON.SIGN_OUT" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
